import { render } from "./BetaTag.vue?vue&type=template&id=2737f6b2&scoped=true"
import script from "./BetaTag.vue?vue&type=script&lang=js"
export * from "./BetaTag.vue?vue&type=script&lang=js"

import "./BetaTag.vue?vue&type=style&index=0&id=2737f6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2737f6b2"]])

export default __exports__